import React from 'react';
import '../style/userLayout.css';
import HeaderItem from './headerItem';
import BreadCrumb from "./breadcrumb";
import {isAdminUser, isAragUser} from "../helpers/functions";
import {NavLink} from "react-router-dom";
import FormResponseMessage from "./formResponseMessage";
import { LEGAL_ADVICE_TEXT, TOBA_PATH, TOBA_SHORT_TEXT } from '../helpers/variables';
import aragLogo from '../araglogo3@2x.png';

const ADMIN_MENU = [
	{href: '/newUser', title: 'Create User'},
	{href: '/users', title: 'View users'},
];

const LayoutHeader = (props) => {

	let settingsMenu = [];
	settingsMenu.push( {href: '/editing-settings', title: 'Editing Settings'} );
	if(props.allowedToEditReferralSettings) {
		settingsMenu.push( {href: '/app-form-referral-settings', title: 'Referral Settings'} );
	}
	if(props.allowedToEditPremiumSettings) {
		settingsMenu.push( {href: '/premium-settings', title: 'Premium Settings'} );
	}
	if(props.allowedToEditArticles) {
		settingsMenu.push( {href: '/articles', title: 'Articles'} );
	}
	if(props.allowedToEditTobas) {
		settingsMenu.push({ href: `/solicitors/${TOBA_PATH}s`, title: `${TOBA_SHORT_TEXT}s` } );
	}
	settingsMenu.push( {href: '/internal-alerts', title: 'Internal Alerts'} );
	let agentsMenu = [];
	agentsMenu.push( {href: '/solicitors', title: `${LEGAL_ADVICE_TEXT}s (ATE)`} );
	agentsMenu.push( {href: '/brokers', title: 'Brokers (BTE)'} );
	return (
		<div className="row user-layout-header print">
			<div className="row user-layout-header-row-1">
				<div style={{
					position: 'relative',
					width: '55px',
					height: 'inherit',
					display: 'inline-block',
					// marginRight: '10px',
					float: 'left'
				}}>
					<img className="user-layout-header-logo" src={aragLogo} alt=""
							 onClick={() => props.push('/')}/>
				</div>
				{isAdminUser(props.userRoles) ?
					<HeaderItem
						dropDownMenu={ADMIN_MENU}
						isDropDown={true}
						title="ARAG Users"
					/> : null
				}
				{isAragUser(props.userRoles) && agentsMenu.length > 0 ?
					<HeaderItem
						dropDownMenu={agentsMenu}
						isDropDown={true}
						title="Users"
					/> : null
				}

				{isAragUser(props.userRoles) ?
					<HeaderItem
						title="Quotes"
						href="/quotes"
					/>
					: null
				}
				{isAragUser(props.userRoles)?
					<HeaderItem
						title="Applications & Policies"
						href="/application-and-policies"
					/> : null
				}
				{isAragUser(props.userRoles) ?
					<HeaderItem
						title="Advance Disbursements"
						href="/advance-disbursements"
					/> : null
				}

				{isAragUser(props.userRoles)?
					<HeaderItem
						title="Notifications"
						href="/notifications"
						icon = {props.notificationsIconCount}
					/> : null
				}
				{isAragUser(props.userRoles) && settingsMenu.length > 0?
					<HeaderItem
						dropDownMenu={settingsMenu}
						isDropDown={true}
						title="Settings"
					/> : null
				}
				<div style={{width: '60px'}} className="user-layout-header-text-div ss">
					<a href="#" onClick={(e) => {
						e.preventDefault();
						props.logout();
					}} style={{paddingLeft: '10px', borderLeft: '1px solid rgba(0, 0, 0, .25)'}}>Log off</a>
				</div>
				<div className="user-layout-header-text-div">
					{
						isAragUser(props.userRoles) && !isAdminUser(props.userRoles) ?
							<NavLink onClick={() => null} to={"/manage-user-account"} >
								<span style={{marginRight: '10px'}}>{props.forename}</span>
							</NavLink>
							:
							<div style={{marginRight: '10px', transform: "translateY(118%)"}}>{props.username}</div>
					}

				</div>

			</div>
			<div className="col-sm-12 burgerMenu2Setting">
				<hr className="user-layout-header-row-rule"/>
			</div>
			<div className="row user-layout-header-row-2">
				<BreadCrumb
					PathName={props.locationPathName}
					Push={props.push}
					BreadcrumbStyle="user-layout-footer-breadcrumb "
					Wrapper="user-layout-footer-breadcrumb-wrapper"/>
			</div>
		</div>
	)
};

export default LayoutHeader;
